<ng-container *ngrxLet="matchBreakdown$ | async as matchBreakdown">
    @if (!isLoading && matchBreakdown) {
        <div class="nova__dialog__toolbar">
            <div class="nova__dialog__toolbar__title">
                {{ jobTitle }}
            </div>
            <div class="nova__dialog__toolbar__controls">
                <button
                    class="nova__button--icon"
                    mat-dialog-close
                    data-qa-id="match-breakdown-dialog-close-btn">
                    <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
                </button>
            </div>
        </div>

        <div
            mat-dialog-content
            #content
            class="nova__dialog__content space-between"
            [ngClass]="{
                job__content: isJobScreen,
                submittal__content: !isJobScreen,
                'pt-4': true
            }">
            <nova-match-breakdown
                [matchBreakdown]="matchBreakdown"
                [isJobScreen]="isJobScreen"
                [jobTitle]="jobTitle"
                [jobDescription]="jobDescription"
                [isJobDetailsOnly]="isJobDetailsOnly"
                [candidateName]="candidateName"
                [matchCategory]="matchCategory"
                [hideReviewNotes]="hideReviewNotes">
            </nova-match-breakdown>
        </div>
        <div
            mat-dialog-content
            class="nova__dialog__content flex-col space-between"
            [ngClass]="{ job__content: isJobScreen, submittal__content: !isJobScreen }">
            <mat-dialog-actions class="nova__dialog__content__actions actions">
                <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </mat-dialog-actions>
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="loadingContent"></ng-container>
    }
</ng-container>

<ng-template #loadingContent>
    <div class="nova__dialog__toolbar">
        <div class="nova__dialog__toolbar__title"> Loading... </div>
        <div class="nova__dialog__toolbar__controls">
            <button
                class="nova__button--icon"
                mat-dialog-close
                data-qa-id="match-breakdown-dialog-loading-close-btn">
                <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
            </button>
        </div>
    </div>

    <div
        mat-dialog-content
        class="nova__dialog__content space-between"
        [ngClass]="{ job__content: isJobScreen, submittal__content: !isJobScreen }">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <div
        mat-dialog-content
        class="nova__dialog__content flex-col space-between"
        [ngClass]="{ job__content: isJobScreen, submittal__content: !isJobScreen }">
        <mat-dialog-actions class="nova__dialog__content__actions actions">
            <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #actionButtons>
    @if (!continueCallBackFunc) {
        <button
            mat-flat-button
            (click)="close()"
            color="primary"
            data-qa-id="match-breakdown-dialog-action-close-btn"
            >CLOSE</button
        >
    } @else {
        @if (!isContinueEnabled) {
            <div>Scroll to continue</div>
        }
        <div class="buttons">
            <button
                mat-flat-button
                [disabled]="!isContinueEnabled"
                (click)="continue()"
                color="primary"
                data-qa-id="match-breakdown-dialog-action-continue-btn"
                >CONTINUE</button
            >
            <button
                mat-stroked-button
                (click)="close()"
                color="secondary"
                data-qa-id="match-breakdown-dialog-action-cancel-btn"
                >CANCEL</button
            >
        </div>
    }
</ng-template>
